import React, { lazy } from 'react';
import { useTranslation } from 'react-i18next';
import { format } from 'date-fns';
import styled from 'styled-components';
import { Field } from 'react-final-form';

import { Box as MuiBox, Typography as MuiTypography } from '@mui/material';
import Calendar from 'react-calendar';

import { SCalendarWrap } from 'pages/SchedulePage/styled/chooseDateDialog';

const DialogCalendarComponent = (props) => {
  const { t } = useTranslation();
  const {
    selectedDate,
    maxCalendarDate,
    setSelectedDate,
    currentDate,
    selectedMonth,
    setSelectedMonth,
    selectRange,
    allowPartialRange,
    name,
    isHasMinDate = true,
    calendarRef,
  } = props;

  return (
    <SCalendarWrap>
      <Field name={name} component="input" value={selectedDate}>
        {({ input, meta }) => (
          <>
            <SSmallCalendarContainer>
              <SMuiTypography variant="h5" color="textSecondary">
                1 - {t('Select the year')}
              </SMuiTypography>
              <SCalendar
                afterContent={`2 - ${t('Select the month')}`}
                locale="en-En"
                maxDetail="year"
                minDetail="year"
                defaultView="year"
                prev2Label={null}
                next2Label={null}
                value={selectedMonth ? selectedMonth : selectedDate}
                minDate={isHasMinDate ? currentDate : new Date('01-01-1920')}
                maxDate={maxCalendarDate}
                formatMonth={(locale, date) => t(format(date, 'MMMM'))}
                onChange={(value) => {
                  setSelectedMonth
                    ? setSelectedMonth(value)
                    : setSelectedDate(value);
                  input.onChange(value);
                }}
              />
            </SSmallCalendarContainer>
            <SBigCalendarContainer>
              <SMuiTypography variant="h5" color="textSecondary">
                3 - {t('Select the day or range of dates')}
              </SMuiTypography>
              <SCalendar
                calendarRef={calendarRef}
                locale="en-En"
                minDate={isHasMinDate ? currentDate : new Date('01-01-1920')}
                value={selectedDate}
                defaultValue={selectedDate}
                showNavigation={false}
                allowPartialRange={allowPartialRange}
                formatShortWeekday={(locale, date) => t(format(date, 'EEE'))}
                onChange={(value) => {
                  setSelectedDate(value);
                  input.onChange(value);
                }}
                activeStartDate={selectedMonth}
                selectRange={!!selectRange}
              />
            </SBigCalendarContainer>
          </>
        )}
      </Field>
    </SCalendarWrap>
  );
};

export const SCalendar = styled(({ calendarRef, theme, ...props }) => (
  <Calendar {...props} ref={calendarRef} />
))`
  && {
    border: none;

    .react-calendar__navigation::after {
      position: absolute;
      content: ${({ afterContent }) =>
        afterContent ? `"${afterContent}"` : ''};
      bottom: 2px;
      font-weight: 600;
      color: ${({ theme }) => theme.palette.colors.gray400};
    }
  }
`;
const SSmallCalendarContainer = styled(({ theme, ...props }) => (
  <MuiBox {...props} />
))`
  && {
    display: flex;
    flex-direction: column;
    flex: 1 35%;
    border-right: 1px solid ${({ theme }) => theme.palette.colors.gray200};
    padding-right: 20px;
    .react-calendar {
      width: 100%;
      margin: 0;
    }
  }
`;
export const SBigCalendarContainer = styled(MuiBox)`
  display: flex;
  flex: 1 50%;
  flex-direction: column;
  padding-left: 35px;
  .react-calendar {
    width: 100%;
    margin: 0;
  }
`;

export const SMuiTypography = styled(MuiTypography)`
  margin-bottom: 20px;
  margin-top: 5px;
`;

export default DialogCalendarComponent;
